// extracted by mini-css-extract-plugin
export default {"NewFolder":"FolderDialog_NewFolder__cEiu9","NewFolder__Input":"FolderDialog_NewFolder__Input__wyj1l","NewFolder__Actions":"FolderDialog_NewFolder__Actions__+Et6p"};